export const servicepointLinks = {
  servicepointMapLink: () => '',
}
